import { render, staticRenderFns } from "./editorButton.vue?vue&type=template&id=12672579&scoped=true"
import script from "./editorButton.vue?vue&type=script&lang=js"
export * from "./editorButton.vue?vue&type=script&lang=js"
import style0 from "./editorButton.vue?vue&type=style&index=0&id=12672579&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12672579",
  null
  
)

export default component.exports